import { OZ, CANDY_APPLE } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ActionExplainerComponents from 'automation-ui-action-features/actions/ActionExplainerComponents';
import ActionPopoverAddonComponents from 'automation-ui-action-features/actions/ActionPopoverAddonComponents';
import DetailsPopoverContent from 'automation-ui-action-features/action-details/DetailsPopoverContent';
import DetailsPopoverSection from 'automation-ui-action-features/action-details/DetailsPopoverSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ActionDetailsPopover({
  action,
  headerIconName,
  headerIconUrl,
  theme,
  getHeaderTitle,
  validationErrors,
  flowObjectTypeId,
  getActionOutputsForTargetActionById
}) {
  const actionType = action.getActionType();
  const actionId = action.getActionId();
  const ActionExplainerComponent = ActionExplainerComponents[actionType];
  if (!ActionExplainerComponent) {
    throw new Error(`Unrecognized action type: ${actionType}. Please add it to ActionExplainerComponents.`);
  }
  const PopoverAddonComponents = ActionPopoverAddonComponents[actionType];
  const numValidationErrors = validationErrors ? validationErrors.size : 0;
  let statusIcon;
  let statusColor;
  if (numValidationErrors > 0) {
    statusIcon = 'warning';
    statusColor = CANDY_APPLE;
  } else {
    statusIcon = 'success';
    statusColor = OZ;
  }
  return /*#__PURE__*/_jsxs(DetailsPopoverContent, {
    headerIconName: headerIconName,
    headerIconUrl: headerIconUrl,
    headerTitle: getHeaderTitle({
      actionId
    }),
    theme: theme,
    statusIcon: statusIcon,
    statusColor: statusColor,
    statusText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-action-features.action-details.status.changes-needed",
      options: {
        count: numValidationErrors
      }
    }),
    children: [/*#__PURE__*/_jsx(DetailsPopoverSection, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-action-features.action-details.detail-heading"
      }),
      children: /*#__PURE__*/_jsx(ActionExplainerComponent, {
        action: action,
        flowObjectTypeId: flowObjectTypeId,
        getActionLabelById: getHeaderTitle,
        getActionOutputsForTargetActionById: getActionOutputsForTargetActionById
      })
    }), PopoverAddonComponents && /*#__PURE__*/_jsx(PopoverAddonComponents, {
      action: action,
      flowObjectTypeId: flowObjectTypeId,
      getActionLabelById: getHeaderTitle,
      getActionOutputsForTargetActionById: getActionOutputsForTargetActionById
    })]
  });
}
export default ActionDetailsPopover;